import { parseJSON } from './utils';
const baseURL = process.env.VUE_APP_API_HOST;

const transformRequest = (jsonData = {}) =>
	'?' +
	Object.entries(jsonData)
		.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
		.join('&');

const pruneObject = obj => obj && Object.fromEntries(Object.entries(obj).filter(([k, v]) => v !== void 0));

export const sendRequest = (method, api, body, headers, { json, noBase, useRoot } = {}) =>
	new Promise((resolve, reject) => {
		let base = baseURL;
		if (['UPLOAD'].includes(method)) {
			method = 'POST';
		} else {
			body = pruneObject(body);
			if (json) {
				body = JSON.stringify(body);
			} else if (['GET', 'DELETE'].includes(method) || json) {
				api = body ? `${api}${transformRequest(body)}` : api;
				body = undefined;
			} else {
				const formData = new FormData();
				Object.entries(body || {}).forEach(([key, value]) => {
					formData.append(key, value);
				});
				body = formData;
			}
		}

		if (useRoot) {
			base = base.replace(/(\/[\w-]+)+\/?$/, '');
		}

		api = noBase || !api.startsWith('/') ? api : base + '/' + api;
		api = api.replace(/\/\/+/g, '/').replace(/:\/(?!\/)/g, '://');

		fetch(api, {
			method,
			mode: 'cors',
			headers: {
				// 'Content-Type': 'application/json;charset=utf-8',
				// 'Content-Type': 'application/x-www-form-urlencoded',
				...headers
			},
			body
		})
			.then(response => {
				if (response.ok) {
					response
						.text()
						.then(text => {
							try {
								const json = parseJSON(text);
								resolve(json);
							} catch (ex) {
								if (!text?.trim()) {
									resolve();
									return;
								}
								reject(text);
							}
						})
				} else {
					reject(response);
				}
			})
			.catch(ex => {
				reject(ex);
			});
	});

export const post = async (api, body, headers, config) => await sendRequest('POST', api, body, headers, config);
export const get = async (api, body, headers, config) => await sendRequest('GET', api, body, headers, config);
export const put = async (api, body, headers, config) => await sendRequest('PUT', api, body, headers, config);
export const del = async (api, body, headers, config) => await sendRequest('DELETE', api, body, headers, config);
export const upload = async (api, file, headers, config) => await sendRequest('UPLOAD', api, file, headers, config);

export default {
	post,
	get,
	put,
	del,
	upload,
	sendRequest
};
